<div class="holdings-container">
  <div class="holdings-controls">
    <mat-button-toggle-group [value]="holdingsViewMode" (change)="onHoldingsViewModeChange($event.value)" hideSingleSelectionIndicator>
      <mat-button-toggle value="year">By Year</mat-button-toggle>
      <mat-button-toggle value="company">By Company</mat-button-toggle>
    </mat-button-toggle-group>

    @if (holdingsViewMode === 'year') {
      <mat-form-field appearance="fill" class="holdings-selector">
        <mat-label>Year</mat-label>
        <mat-select [(value)]="selectedYear" (selectionChange)="onHoldingsGroupChange()">
          @for (opt of yearOptions; track opt.key) {
            <mat-option [value]="opt.key">{{ opt.label }} ({{ opt.count | number }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (holdingsViewMode === 'company') {
      <mat-form-field appearance="fill" class="holdings-selector">
        <mat-label>Company</mat-label>
        <mat-select [(value)]="selectedCompanyId" (selectionChange)="onHoldingsGroupChange()">
          @for (opt of companyOptions; track opt.key) {
            <mat-option [value]="opt.key">{{ opt.label }} ({{ opt.count | number }})</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field appearance="fill" class="holdings-search">
      <mat-label>Search</mat-label>
      <input matInput [value]="holdingsFilter" (input)="applyHoldingsFilter($event)" placeholder="Filter...">
      @if (holdingsFilter) {
        <button mat-icon-button matSuffix (click)="holdingsFilter = ''; holdingsDataSource.filter = ''; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  @if (holdingsDataSource.data.length === 0 && !holdingsFilter) {
    <div class="empty-state">No holdings available</div>
  } @else {
    <div class="holdings-list">
      @if (holdingsViewMode === 'year') {
        <table mat-table [dataSource]="holdingsDataSource" matSort class="mat-elevation-z2 holdings-table">
          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
            <td mat-cell *matCellDef="let h">
              <span class="name-cell">
                <a [routerLink]="['/companies/edit', h.companyId]" [queryParams]="{tab: 'ownership', year: selectedYear}" class="company-link-btn" title="Go to ownership tab" (click)="$event.stopPropagation()">
                  <mat-icon>open_in_new</mat-icon>
                </a>
                {{ h.companyName }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="firstClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.firstClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="firstClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.firstClassShares) }}</td>
          </ng-container>
          <ng-container matColumnDef="secondClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.secondClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="secondClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.secondClassShares) }}</td>
          </ng-container>
          <ng-container matColumnDef="thirdClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.thirdClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="thirdClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.thirdClassShares) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="holdingsByYearDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: holdingsByYearDisplayedColumns;"></tr>
        </table>
      }

      @if (holdingsViewMode === 'company') {
        <table mat-table [dataSource]="holdingsDataSource" matSort class="mat-elevation-z2 holdings-table">
          <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
            <td mat-cell *matCellDef="let h">
              <a [routerLink]="['/companies/edit', h.companyId]" [queryParams]="{tab: 'ownership', year: h.year}" class="company-link-btn" title="Go to ownership tab" (click)="$event.stopPropagation()">
                {{ h.year }}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="firstClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.firstClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="firstClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.firstClassShares) }}</td>
          </ng-container>
          <ng-container matColumnDef="secondClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.secondClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="secondClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.secondClassShares) }}</td>
          </ng-container>
          <ng-container matColumnDef="thirdClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class %</th>
            <td mat-cell *matCellDef="let h">{{ formatPercentage(h.thirdClassSharesPercentage) }}</td>
          </ng-container>
          <ng-container matColumnDef="thirdClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
            <td mat-cell *matCellDef="let h">{{ formatNumber(h.thirdClassShares) }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="holdingsByCompanyDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: holdingsByCompanyDisplayedColumns;"></tr>
        </table>
      }
    </div>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
  }
</div>
